import { combineReducers } from 'redux'

import user from './user'
import modaisReducer from './modaisReducer'

export default combineReducers({
    user,
    modaisReducer
})


// WEBPACK FOOTER //
// ./src/store/reducers/index.js